export class Exhibition {
    rodeoEventScheduleId: number;
    id: number;
    name: string;
    date: string;
    cost: number;
    bulkCost: number;
    bulkThreshold: number;
    maxRuns: number;
    maxEntriesPerContestant: number;

    currentCount: number;
}


// WEBPACK FOOTER //
// ./src/model/exhibition.ts